import axios from 'axios'
import Qs from 'qs'
import {
  requestSuccessInterceptor,
  requestErrorInterceptor
} from '../api/request-interceptors'
import {
  responseSuccessInterceptor,
  responseErrorInterceptor
} from '../api/response-interceptors'

const _axios = axios.create({
  paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
  headers: {
    'Accept-Version': '1.28',
    'Accept-Language': 'fa'
  }
})

_axios.interceptors.response
  .use(responseSuccessInterceptor, responseErrorInterceptor)
_axios.interceptors.request
  .use(requestSuccessInterceptor, requestErrorInterceptor)

export default _axios
